// 定义仓库变量
// 按类划分
export default {
	/** 加载状态 **/
	loading: false,

	/** 下一个 **/
	storeStockSubsData: null
};
